<template>
  <main class="patch_form patch_form__without-bottom">
    <div v-if="!showAppointment && !completed" class="form-inputs">
      <div class="patch_form_section patch_form__section__notice">
        <div class="patch_form__section__notice__content">
          <h2>{{ title }}</h2>
          <p v-for="desc in description" :key="desc">{{ desc }}</p>
        </div>
        <div class="patch_form__section__notice__mole patch_form__section__notice__mole--mole1"></div>
        <div class="patch_form__section__notice__mole patch_form__section__notice__mole--mole2"></div>
      </div>

      <!-- Form -->
      <div v-if="!showLoading && !showSuccess" id="form_step" class="patch_form_section patch_form__section__form">
        <div class="patch_form__section__form__content">
          <FormulateForm v-model="data" :errors="errors" :schema="schema" @backButton="handleBack" @submit="submitForm" />
        </div>
      </div>

      <!-- Loading -->
      <div v-show="showLoading" id="loading_step" class="patch_form_section patch_form__section__loading">
        <div class="patch_form__section__loading__content">
          <div class="loading__animation-container">
            <div id="loading-animation" class="loading__animation"></div>
          </div>
          <p class="loading__message">Ponte el cinturón que estamos despegando...</p>
        </div>
      </div>

      <!-- Thank you -->
      <div v-show="showSuccess" id="success_step" class="patch_form_section patch_form__section__success">
        <div class="patch_form__section__success__content">
          <div class="success__message-container">
            <img class="success__image" src="img/web/icons/inmueble.svg" alt="" title="" />
            <h2 class="success__title">¡Muchas gracias!</h2>
            <p class="success__subtitle">
              Uno de nuestros expertos se pondrá en contacto contigo en las próximas horas para ofrecerte la mejor solución personalizada.
              Mientras tanto puedes:
            </p>
          </div>
          <div class="success__buttons">
            <button
              v-if="thanksButtons.includes('phone-date') && canScheduleAppointment && !isResell"
              title="Agendar tu cita telefónica"
              @click="showAppointmentStep()"
            >
              Agenda tu <br />cita telefónica
              <img src="img/web/form/right-arrow-btn.svg" alt="Reservar una cita telefónica" />
            </button>
            <a
              v-if="thanksButtons.includes('calculator')"
              :href="calculatorUrl"
              title="Calcular la cuota mensual de tu hipoteca"
              @click="handleCalculator"
            >
              Calcular la cuota <br />mensual de tu hipoteca
              <img src="img/web/form/right-arrow-btn.svg" alt="Calcular la cuota mensual de tu hipoteca" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAppointment && canScheduleAppointment">
      <Loading v-if="loading"></Loading>
      <MoleContainer color="moles--warning">
        <FormulateForm
          :errors="formErrors"
          class="formulate-form--in-moles"
          v-model="form"
          :schema="fields"
          @submit="handleAppointment"
          @handleTimeChange="handleTimeChange"
          @handleDayChange="handleDayChange"
        />
      </MoleContainer>
    </div>
    <div v-if="completed">
      <TheEndContent
        :notFunnel="true"
        :datetime="form.needAttentionDatetime.toString()"
        :customerService="customerService"
        :score="4.9"
      ></TheEndContent>
    </div>
  </main>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
import { dataLayerPushPage, dataLayerPushEvent } from '@/web/util';
import appointment from '@/funnels/mixins/appointment';
import Lottie from 'lottie-web';
import TheEndContent from '@/funnels/pages/funnels/TheEndContent.vue';

export default {
  components: { TheEndContent },
  mixins: [appointment],
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    description: {
      type: Array,
      default: () => [],
    },
    schema: {
      type: Array,
      default: () => [],
    },
    thanksButtons: {
      type: Array,
      default: () => [],
    },
    occupancy: {
      type: Object,
    },
    provinces: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showLoading: false,
      showSuccess: false,
      showAppointment: false,
      completed: false,
      loading: false,
      availability: null,
      slotDuration: 30,
      customerService: null,
      data: {
        name: null,
        surname: null,
        phone: null,
        email: null,
        form_price: null,
        province_id: null,
        occupancy: null,
        initialSignatureDate: null,
        years: null,
        amount_borrowed: null,
        termsConsent: false,
        isNewsletterSubscriber: false,
      },
      form: {
        needAttentionDatetime: null,
      },
      mortgage: null,
      canScheduleAppointment: true,
      isResell: false,
      name: null,
      phone: null,
      errors: {},
    };
  },
  created() {
    dataLayerPushPage('form', this.type, null, `Web-Simulador`, '/web/simulador');
  },
  computed: {
    calculatorUrl() {
      return route('calculator.view');
    },
    location() {
      return window.location.pathname;
    },
    backButton() {
      return {
        component: 'a',
        class: 'btn btn-ghost btn-lg',
        children: 'Volver',
        '@click': this.showSuccessStep,
      };
    },
    submitButton() {
      return {
        type: 'submit',
        name: 'submit',
        label: 'Confirmar cita',
        disabled: this.form.processing,
      };
    },
    buttons() {
      return {
        component: 'div',
        class: 'btn-container',
        children: [this.backButton, this.submitButton].filter(n => n),
      };
    },
    fields() {
      const schema = [
        this.needAttentionField,
        this.needAttentionDayField,
        this.needAttentionTimeField,
        this.confirmNameField,
        this.confirmPhoneField,
        this.buttons,
      ];
      if (this.form.needAttentionDay && this.form.needAttentionTime) {
        schema.splice(3, 0, this.preview);
      }
      return schema;
    },
  },
  methods: {
    async submitForm() {
      const province = this.provinces.filter(p => p.value === this.data.province_id)[0];
      var content = {
        'tipo-solicitud': this.type === 'improve' ? 'MEJORA HIPOTECA' : 'NUEVA HIPOTECA',
        'provincia-hipoteca': province.label.toUpperCase(),
        'uso-vivienda': this.occupancy[this.data.occupancy].toUpperCase(),
        'fecha-firma': this.data.initialSignatureDate,
        'pendiente-pagar': this.data.amount_borrowed,
      };

      dataLayerPushEvent('form', this.type, 'Click', 'Empecemos', content);

      this.showLoadingStep();
      try {
        this.name = this.data.name;
        this.phone = this.data.phone;
        const self = this;
        await axios.post(window.location.pathname, this.data).then(data => {
          self.canScheduleAppointment = !data.data.hasAppointment;
          self.isResell = data.data.isResell;
          self.mortgage = data.data.mortgage;
        });
        setTimeout(this.showSuccessStep, 1000);
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          // Show form with errors
          this.showFormStep();
          this.errors = e.response.data.errors;
        }
      }
    },
    async handleAppointment() {
      dataLayerPushEvent('form', this.type, 'Click', 'confirmar-cita', {
        'fecha-cita': this.form.needAttentionDatetime,
      });

      const self = this;
      await axios
        .post(route('mortgages.improve.store.appointment'), this.form)
        .then(data => {
          self.customerService = data.data.customerService;
          self.showAppointment = false;
          self.completed = true;
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.errors) {
            this.errors = e.response.data.errors;
          }
        });
    },
    showFormStep() {
      this.showLoading = false;
      this.showSuccess = false;
    },
    showLoadingStep() {
      this.showSuccess = false;
      this.showLoading = true;
    },
    showSuccessStep(e) {
      this.showLoading = false;
      this.showSuccess = true;
      if (e) {
        this.showAppointment = false;
      }
    },
    showAppointmentStep() {
      dataLayerPushEvent('form', this.type, 'Click', 'agenda-cita');

      this.showAppointment = true;
      this.form.name = this.name;
      this.form.phone = this.phone;
      this.form.mortgage = this.mortgage;
      this.form.needAttentionDay = moment().format('YYYY-MM-DD');
      this.handleDayChange(this.form.needAttentionDay);

      dataLayerPushPage(
        'form',
        this.type,
        `/web/simulador/${this.type === 'improve' ? 'descubrir' : 'solicitar'}-hipoteca/reserva-cita`,
        `Web-Simulador`
      );
    },
    handleBack() {
      dataLayerPushEvent('form', this.type, 'Click', 'volver');
    },
    handleCalculator() {
      dataLayerPushEvent('form', this.type, 'Click', 'CalculaHipoteca');
    },
  },
  mounted() {
    window.initTooltip();
    let el = document.getElementById('form-buttons');
    let elFixed = document.getElementById('fixed-form-buttons');
    window.addEventListener('scroll', function() {
      if (el.getBoundingClientRect().top - screen.height > 0) {
        el.classList.add('form-buttons--invisible');
        elFixed.classList.remove('fixed-form-buttons--hidden');
      } else {
        el.classList.remove('form-buttons--invisible');
        elFixed.classList.add('fixed-form-buttons--hidden');
      }
    });
    const animation = Lottie.loadAnimation({
      container: document.getElementById('loading-animation'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'lottie/loading-rocket.json',
    });
  },
  watch: {
    showSuccess() {
      window.history.pushState({}, '', window.location.href + '/thank-you');
      dataLayerPushPage('form', this.type, null, `Web-Simulador`, '/web/simulador');
    },
  },
};
</script>
